import { z } from 'zod';
export const ERROR_CODES = [
    'VALIDATION_ERROR',
    'UNAUTHORIZED',
    'FORBIDDEN',
    /**
     * The request came from a browser origin the server is not configured to
     * accept. A configuration/network problem, never a permission problem: it must
     * not be shown as "this account has no permission".
     */
    'ORIGIN_NOT_ALLOWED',
    'NOT_FOUND',
    'CONFLICT',
    'RATE_LIMITED',
    'PAYLOAD_TOO_LARGE',
    'UNSUPPORTED_MEDIA_TYPE',
    'PRECONDITION_FAILED',
    /** A visit whose check-in is outside every shift of the agent (D110): permanent, never retried. */
    'SHIFT_REQUIRED',
    'ZOHO_NOT_CONFIGURED',
    'ZOHO_ERROR',
    'INTERNAL_ERROR',
];
/** Shape of every non-2xx JSON response from the API. */
export const apiErrorBodySchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
/** A single validation problem, used in `error.details` for VALIDATION_ERROR. */
export const validationIssueSchema = z.object({
    path: z.string(),
    code: z.string(),
    message: z.string(),
});
export function zodIssuesToValidationIssues(error) {
    return error.issues.map((issue) => ({
        path: issue.path.map(String).join('.'),
        code: issue.code,
        message: issue.message,
    }));
}
//# sourceMappingURL=errors.js.map